import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  const scrollToNextSection = () => {
    const comparisonSection = document.getElementById('comparison');
    if (comparisonSection) {
      comparisonSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-amber-50 via-stone-50 to-yellow-50 py-16 md:py-24 pb-12 md:pb-20" data-id="element-99">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-100">
        <div className="absolute top-20 left-10 w-40 h-40 md:w-64 md:h-64 bg-amber-300 rounded-full blur-3xl" data-id="element-101"></div>
        <div className="absolute bottom-20 right-10 w-60 h-60 md:w-96 md:h-96 bg-yellow-300 rounded-full blur-3xl" data-id="element-102"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-6 text-center" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-104">
          <h1 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-stone-900 mb-2 leading-tight" data-id="element-105">
            Como vender lembrancinhas com{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600" data-id="element-106">
              aparência de boutique
            </span>{' '}
            — e cobrar mais por isso
          </h1>

          <p className="text-sm md:text-base text-stone-700 font-light mb-8 max-w-3xl mx-auto leading-relaxed mt-6" data-id="element-107">
            Um método prático para valorizar seus produtos usando apresentação,
            acabamento e detalhes que fazem o cliente aceitar preços mais altos.
          </p>

          {/* Bullets - First Row */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 mb-3 text-stone-800 max-w-4xl mx-auto" data-id="element-108">
            <div className="flex items-center gap-2 bg-white/60 backdrop-blur-sm px-4 py-3 rounded-full shadow-sm border border-stone-200 w-full md:w-auto md:flex-1" data-id="element-109">
              <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-110" />
              <span className="text-sm md:text-base font-medium whitespace-nowrap" data-id="element-111">
                40 ideias com acabamento boutique
              </span>
            </div>
            <div className="flex items-center gap-2 bg-white/60 backdrop-blur-sm px-4 py-3 rounded-full shadow-sm border border-stone-200 w-full md:w-auto md:flex-1" data-id="element-112">
              <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-113" />
              <span className="text-sm md:text-base font-medium whitespace-nowrap" data-id="element-114">
                Custos reais e valor percebido
              </span>
            </div>
          </div>

          {/* Bullets - Second Row */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 mb-10 text-stone-800 max-w-4xl mx-auto" data-id="element-115">
            <div className="flex items-center gap-2 bg-white/60 backdrop-blur-sm px-4 py-3 rounded-full shadow-sm border border-stone-200 w-full md:w-auto md:flex-1" data-id="element-116">
              <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-117" />
              <span className="text-sm md:text-base font-medium whitespace-nowrap" data-id="element-118">
                Para quem quer fazer renda extra
              </span>
            </div>
            <div className="flex items-center gap-2 bg-white/60 backdrop-blur-sm px-4 py-3 rounded-full shadow-sm border border-stone-200 w-full md:w-auto md:flex-1" data-id="element-119">
              <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-120" />
              <span className="text-sm md:text-base font-medium whitespace-nowrap" data-id="element-121">
                Para vendedores de artesanato
              </span>
            </div>
          </div>

          <motion.button onClick={scrollToNextSection} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} className="bg-gradient-to-r from-amber-500 to-yellow-600 hover:from-amber-600 hover:to-yellow-700 text-white font-bold text-lg md:text-xl px-10 py-4 md:px-12 md:py-5 rounded-full shadow-2xl transition-all duration-300 flex items-center gap-2 mx-auto" data-id="element-122">
            👉 Quero ver como funciona
          </motion.button>
        </motion.div>
      </div>

      {/* Decorative bottom wave */}
      <div className="absolute bottom-0 left-0 right-0" data-id="element-123">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-8 md:h-12" preserveAspectRatio="none" data-id="element-124">
          <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#fafaf9" data-id="element-125" />
        </svg>
      </div>
    </section>;
}